import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitorRegistrationMasterdataComponent } from './component/visitor-registration-masterdata.component';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';
import { NumberplateInputModule } from 'src/tmc-common/components/numberplate-input/numberplate-input.module';



@NgModule({
  declarations: [
    VisitorRegistrationMasterdataComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    NumberplateInputModule
  ]
})
export class VisitorRegistrationMasterdataModule { }
